// extracted by mini-css-extract-plugin
export var carrierTab = "_4z-0";
export var carrierTabActive = "_4z-1 _4z-0";
export var carrierTabInactive = "_4z-2 _4z-0";
export var carrierTabLabel = "_4z-3";
export var carrierTabLabelActive = "_4z-4 _4z-3";
export var carrierTabLabelInactive = "_4z-5 _4z-3";
export var carrierTabPercentage = "_4z-6";
export var carrierTabPercentageActive = "_4z-7 _4z-6";
export var carrierTabPercentageInactive = "_4z-8 _4z-6";
export var carrierTabWinnable = "_4z-9";
export var carrierTabWinnableActive = "_4z-a _4z-9";
export var carrierTabWinnableInactive = "_4z-b _4z-9";
export var comparisonContainer = "_4z-d";
export var missingRateButton = "_4z-n";
export var missingRateButtonActive = "_4z-o _4z-n";
export var missingRateButtonInactive = "_4z-p _4z-n";
export var missingRateButtonLabel = "_4z-q";
export var missingRateButtonLabelActive = "_4z-r _4z-q";
export var missingRateButtonLabelInactive = "_4z-s _4z-q";
export var sidebar = "_4z-c";
export var strategyButton = "_4z-e";
export var strategyButtonActive = "_4z-f _4z-e";
export var strategyButtonDescription = "_4z-k";
export var strategyButtonDescriptionActive = "_4z-l _4z-k";
export var strategyButtonDescriptionInactive = "_4z-m _4z-k";
export var strategyButtonInactive = "_4z-g _4z-e";
export var strategyButtonLabel = "_4z-h";
export var strategyButtonLabelActive = "_4z-i _4z-h";
export var strategyButtonLabelInactive = "_4z-j _4z-h";
export var unitToggleButton = "_4z-t";
export var unitToggleButtonActive = "_4z-u _4z-t";
export var unitToggleButtonInactive = "_4z-v _4z-t";
export var unitToggleButtonLabel = "_4z-w";
export var unitToggleButtonLabelActive = "_4z-x _4z-w";
export var unitToggleButtonLabelInactive = "_4z-y _4z-w";